document.querySelectorAll('[data-gallery-src]').forEach(button => {
  button.addEventListener('click', () => {
    const image = document.getElementById('ProductImage');
    if (!image) return;
    image.removeAttribute('srcset');
    image.src = button.dataset.gallerySrc;
    document.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
});
const variantSelect = document.getElementById('ProductVariant');
variantSelect?.addEventListener('change', () => {
  const option = variantSelect.selectedOptions[0];
  document.getElementById('ProductPrice').textContent = option.dataset.price;
  const button = document.getElementById('AddToBag');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
  const image = document.getElementById('ProductImage');
  if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});


(() => {
  const root = document.querySelector('[data-look-bundle]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-bundle-data]').textContent);
  if (!data.pairs.length) return;
  const el = name => root.querySelector('[data-bundle-' + name + ']');
  const currentSize = el('current-size');
  const pairSize = el('pair-size');
  const pairPicker = el('pair');
  const addButton = el('add');
  const error = el('error');
  const mainVariant = document.querySelector('#ProductForm [name="id"]');
  const currency = root.dataset.currency || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100) + ' ' + currency;
  let pending = false;
  let pair = data.pairs[0];
  const variant = (item, selector) => item.variants.find(v => String(v.id) === selector.value);
  const setImage = (name, item) => {
    const image = el(name + '-image');
    image.src = item.image;
    image.alt = item.title;
  };
  function fillSizes(select, item, chosen) {
    select.replaceChildren(...item.variants.map(v => {
      const option = new Option((v.title === 'Default Title' ? 'Standard' : v.title) + (v.available ? '' : ' — Sold out'), String(v.id));
      option.disabled = !v.available;
      return option;
    }));
    const selected = item.variants.find(v => String(v.id) === String(chosen));
    const fallback = item.variants.find(v => v.available) || item.variants[0];
    select.value = String((selected || fallback).id);
    select.disabled = item.variants.length === 1;
  }
  function updateTotal() {
    const a = variant(data.current, currentSize);
    const b = variant(pair, pairSize);
    const available = !!(a && b && a.available && b.available);
    const total = (a?.price || 0) + (b?.price || 0);
    const saving = Math.round(total * 0.05);
    el('original').textContent = money(total);
    el('total').textContent = money(total - saving);
    el('saving').textContent = 'SAVE ' + money(saving);
    addButton.disabled = pending || !available;
    if (!pending) addButton.firstChild.textContent = available ? 'Add bundle to bag ' : 'Choose available sizes ';
  }
  function setPair() {
    pair = data.pairs.find(p => String(p.id) === pairPicker.value);
    el('pair-title').textContent = pair.title;
    el('pair-link').href = pair.url;
    setImage('pair', pair);
    fillSizes(pairSize, pair);
    updateTotal();
  }
  for (const item of data.pairs) pairPicker.add(new Option(item.title, String(item.id)));
  const colour = data.current.title.match(/ - (.+)$/)?.[1]?.toLowerCase();
  const matching = colour && data.pairs.find(p => p.title.toLowerCase().endsWith(' - ' + colour));
  pairPicker.value = String((matching || pair).id);
  el('current-title').textContent = data.current.title;
  setImage('current', data.current);
  fillSizes(currentSize, data.current, mainVariant?.value || data.current.defaultVariant);
  setPair();
  pairPicker.addEventListener('change', setPair);
  pairSize.addEventListener('change', updateTotal);
  currentSize.addEventListener('change', () => {
    if (mainVariant) {
      mainVariant.value = currentSize.value;
      mainVariant.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateTotal();
  });
  mainVariant?.addEventListener('change', () => {
    currentSize.value = mainVariant.value;
    updateTotal();
  });
  addButton.addEventListener('click', async () => {
    if (pending || addButton.disabled) return;
    const a = variant(data.current, currentSize);
    const b = variant(pair, pairSize);
    pending = true;
    error.hidden = true;
    root.setAttribute('aria-busy', 'true');
    addButton.firstChild.textContent = 'Adding your bundle… ';
    updateTotal();
    try {
      const response = await fetch(root.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: a.id, quantity: 1 }, { id: b.id, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this bundle. Please check availability and try again.');
      window.location.assign(root.dataset.cartUrl);
    } catch (exception) {
      error.textContent = exception.message || 'Unable to add this bundle. Please try again.';
      error.hidden = false;
      pending = false;
      root.removeAttribute('aria-busy');
      updateTotal();
    }
  });
  root.hidden = false;
})();